import { UploadFile } from "./upload-file";

export class UploadFileData extends UploadFile {
    isUploadedOnServer: boolean;
    isRemoved: boolean = false;
}